
define('text!modules/strategy/creatives/templates/panel_layout.html',[],function () { return '<div class=\'list-c\'>\n\t<div class=\'filters\'></div>\n\t<div class=\'browse-c\'></div>\n</div>\n';});

